module.exports = __webpack_public_path__ + "img/9.8ead7e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/9.jpg
// module id = 213
// module chunks = 1